<template>
  <div>

    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <!-- <h4 class="mb-1">{{ $t('projects.title') }}</h4>
    <div>
      <span v-if="getGuide('projects')">
        <GuideButton :guide="getGuide('projects')"></GuideButton>
      </span>
    </div>
    <div class="mb-3"></div>

    <div class="card mt-4">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="alert alert-primary color-secondary card-shadow radius-0-5" role="alert">
              <span class="card-background-icon">
                <font-awesome-icon icon="cubes"/>
              </span>
              <h5 class="color-secondary mt-2">
                {{ $t('projects.update_assets_title') }}
              </h5>
              <p style="min-height: 60px;">{{ $t('projects.update_assets_description') }}</p>
              <div class="text-right mt-4">
                <router-link
                    class="btn btn-secondary ml-3"
                    to="/projects/asset-projects"
                    qid="asset-projects-link"
                >
                  <span class="side-nav--text">
                    {{ $t('projects.full_list_button') }}
                  </span>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="alert alert-primary color-secondary card-shadow radius-0-5" role="alert">
              <span class="card-background-icon">
                <font-awesome-icon icon="shield-alt"/>
              </span>
              <h5 class="color-secondary mt-2">
                {{ $t('projects.manage_controls_title') }}
              </h5>
              <p style="min-height: 60px;">{{ $t('projects.manage_controls_description') }}</p>
              <div class="text-right mt-4">
                <router-link
                    class="btn btn-secondary ml-3"
                    to="/projects/control-projects"
                    qid="control-projects-link"
                    v-if="getClient.riskModule"
                >
                  <span class="side-nav--text">
                    {{ $t('projects.full_list_button') }}
                  </span>
                </router-link>
                <a class="btn btn-secondary ml-3"
                   href="https://www.complyon.com/risk-and-control"
                   qid="risk-read-more"
                   target="_blank"
                   v-else
                >
                  <span class="side-nav--text">
                    {{ $t('system.read_more') }}
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="alert alert-primary color-secondary card-shadow radius-0-5" role="alert">
              <span class="card-background-icon">
                <font-awesome-icon icon="file-alt"/>
              </span>
              <h5 class="color-secondary mt-2">
                {{ $t('projects.perform_assessments_title') }}
              </h5>
              <p style="min-height: 60px;">{{ $t('projects.perform_assessments_description') }}</p>
              <div class="text-right mt-4">
                <router-link
                    class="btn btn-secondary ml-3"
                    to="/projects/assessment-projects"
                    qid="assessment-projects-link"
                    v-if="getClient.assessmentModule"
                >
                  <span class="side-nav--text">
                    {{ $t('projects.full_list_button') }}
                  </span>
                </router-link>
                <a class="btn btn-secondary ml-3"
                   href="https://www.complyon.com/project-module"
                   qid="assessment-read-more"
                   target="_blank"
                   v-else
                >
                  <span class="side-nav--text">
                    {{ $t('system.read_more') }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row mt-2">
      <div class="col-sm-12">
        <h4 class="mt-4">
          <button class="btn btn-secondary-dark float-right"
                  @click="handleFilterButton(false)"
                  qid="processes-filter-button"
          >
            <font-awesome-icon icon="filter"/>
          </button>
          <CreateProjectModal
              class="float-right ml-3"
              @reloadContent="loadProjects()"
          ></CreateProjectModal>
          <b-form-input
              type="text"
              v-model="filters.keywordValue"
              class="float-right mw-300 search-bar"
              qid="search-p-input"
              v-on:input="debounceInput"
              :placeholder="$t('projects.search_placeholder')"
          ></b-form-input>
          {{ $t('projects.in_progress_title') }}
        </h4>
        <span v-if="getGuide('gantt_page')">
          <GuideButton :guide="getGuide('gantt_page')"></GuideButton>
        </span>
      </div>
    </div>

    <div class="row" v-if="loadingOpen">
      <div class="col-sm-12">
        <div class="mt-3 text-center">
          <h1>
            <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
          </h1>
        </div>
      </div>
    </div>

    <div class="row"  :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-9 table-container" >
        <div v-if="!loadingOpen && tasks && tasks.length">
          <gantt-elastic :tasks="tasks" :options="options" @chart-task-click="showTask" class="table" :dynamic-style="dynamicStyle">
            <gantt-header slot="header" :options="headerOptions" :dynamic-style="headerStyle"></gantt-header>
          </gantt-elastic>
        </div>

        <div v-if="!loadingOpen && !tasks.length">
          <div class="card">
            <div class="card-body text-center">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </div>
          </div>
        </div>

      </div>



      <div class="col-sm-3 filter-container">
        <div class="card">
          <div class="card-body">
            <b-form-group>
              <label qid="filter-p-type-label">
                {{ $t('projects.filters.type_label') }}
              </label>
              <multiselect
                  v-model="filters.types"
                  :options="types"
                  :multiple="true"
                  :placeholder="$t('projects.filters.type_placeholder')"
                  @select="debounceInput"
                  @remove="debounceInput"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  track-by="value"
                  label="name"
                  qid="filter-p-type"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="create-s-users-label">
                {{ $t('generic_controls.create.owners_label') }}
              </label>
              <multiselect
                  v-model="filters.owners"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :options="users"
                  :multiple="true"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :taggable="false"
                  track-by="slug"
                  :placeholder="$t('generic_controls.create.owners_placeholder')"
                  label="name"
                  @search-change="loadUsers"
                  qid="filter-s-form-owners"
              >
                <template slot="tag" slot-scope="props">
                  <span class="mr-3 user-tag">
                    <Avatar :object="props.option" size="xs"></Avatar>
                    <span class="ml-2">{{ props.option.name }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
              </multiselect>
            </b-form-group>
            <!--<b-form-group>-->
              <!--<label qid="create-s-users-label">-->
                <!--{{ $t('projects.filters.future_projects_label') }}-->
              <!--</label>-->
              <!--<b-form-radio-group-->
                <!--@change="debounceInput"-->
                <!--v-model="filters.future_projects"-->
                <!--:options="checklistOptions"-->
                <!--track-by="value"-->
              <!--&gt;</b-form-radio-group>-->
            <!--</b-form-group>-->
            <b-form-group>
              <label qid="create-do-tags-label">
                {{ $t('processes.create.tags_label') }}
              </label>
              <multiselect
                      v-model="filters.tags"
                      @select="debounceInput"
                      @remove="debounceInput"
                      :options="tags"
                      :multiple="true"
                      :taggable="true"
                      select-label="✔"
                      selected-label="✔"
                      deselect-label="x"
                      track-by="name_translated"
                      :placeholder="$t('processes.create.tags_placeholder')"
                      label="name_translated"
                      qid="filter-p-form-tags"
                      @search-change="loadTags"
                      @tag="addTag"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="create-s-users-label">
                {{ $t('projects.filters.overdue_projects_label') }}
              </label>
              <b-form-radio-group
                @change="debounceInput"
                v-model="filters.overdue_projects"
                :options="checklistOptions"
                track-by="value"
              ></b-form-radio-group>
            </b-form-group>


            <a href="#" @click="resetFilters" class="text-right" qid="filter-s-reset">
              {{ $t('system.reset_filters') }}
            </a>
          </div>
        </div>
      </div>

    </div>



    <div class="mt-3 pagination row">
      <div class="col-md-6">
        <div class="row">
          <div class="float-left">
            <span class="text-muted pagination-counter">
              {{ $t('pagination.entries_per_page') }}:
            </span>
          </div>
          <div class="float-left">
            <multiselect
                v-model="perPage"
                :options="perPageOptions"
                track-by="value"
                label="value"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-org-form-organization-level"
                @select="perPageChanged"
                :placeholder="selectedPerPage"
                @remove="perPageRemoved"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="selectedPerPage"
            aria-controls="my-table"
            @change="pageChanged"
            limit="1"
        >
          <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
          <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
          <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
          <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
          <div slot="ellipsis-text">
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
          </div>
          <span class="text-muted" slot="page" slot-scope="{ page, active }">
            <span v-if="active">{{getPerPage}}</span>
          </span>
        </b-pagination>
      </div>
    </div>

    <ProjectViewModal
        :slug="selectedProjectSlug"
        :showModal="viewProjectModal"
        @closeViewModal="closeViewProjectModal"
    ></ProjectViewModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </div>
</template>

<script>

import piincHttp from '@/util/configureAxios.js'
import Avatar from '@/components/Avatar.vue';
import CreateProjectModal from '@/views/Projects/CreateProjectModal.vue'
import {GGanttChart, GGanttRow} from 'vue-ganttastic'
import GanttElastic from "gantt-elastic";
import ProjectViewModal from '@/views/Projects/ProjectViewModal.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';
import GanttHeader from "@/plugins/Header";
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'ProjectsLanding',
  data() {
    return {
      dynamicStyle: {
        'task-list-header-label': {
          'font-weight': 'bold',
        },
      },
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('projects.title'),
          active: true
        }
      ],
      users: [],
      filterOpened: false,
      filters: {
        owners: [],
        tags: [],
        types:[
          { name: this.$t('projects.type.update'), value: 'update' },
          { name: this.$t('projects.type.validation'), value: 'validation' },
          { name: this.$t('projects.type.control'), value: 'control' },
          { name: this.$t('maintenance.assessments.type.control_assessment'), value: 'control_assessment' },
          { name: this.$t('maintenance.assessments.type.risk_assessment'), value: 'risk_assessment' },
          { name: this.$t('maintenance.assessments.type.bia_assessment'), value: 'bia_assessment' }
        ],
        future_projects: '',
        overdue_projects: 0,
        keywordValue: ''
      },
      tags: [],
      loadingOpen: true,
      myProjectTemplatesOpen: [],
      loadingProjectTemplates: true,
      projectTemplatesShowMore: true,
      projectTemplatesPage: 1,
      myGuides: [],
      selectedProjectSlug: '',
      viewProjectModal: false,
      selectedItem: {},
      showUsersModal: false,

      // Pagination
      perPageOptions: [
        { name: '5', value: '5' },
        { name: '10', value: '10' },
        { name: '20', value: '20' }
      ],
      types: [
        { name: this.$t('projects.type.update'), value: 'update' },
        { name: this.$t('projects.type.validation'), value: 'validation' },
        { name: this.$t('projects.type.control'), value: 'control' },
        { name: this.$t('maintenance.assessments.type.control_assessment'), value: 'control_assessment' },
        { name: this.$t('maintenance.assessments.type.risk_assessment'), value: 'risk_assessment' },
        { name: this.$t('maintenance.assessments.type.bia_assessment'), value: 'bia_assessment' }
      ],
      checklistOptions: [
        {text: this.$t('system.off'), value: 0},
        {text: this.$t('system.on'), value: 1}
      ],
      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,

      tasks: [],

      headerOptions: {
        title: {
          label: '',
          html: true
        },
        divider: false,
        locale: {
          'Now': 'Now',
          'X-Scale': 'Zoom',
          'Y-Scale': 'Height',
          'Task list width': 'Task list',
          'Before/After': 'Expand',
          'Display task list': 'Task list'
        },
      },
      headerStyle: {
        header: {
          margin: "0px auto",
          background: "#f3f5f747",
          padding: "10px",
          overflow: "hidden",
          clear: "both",
          display: "flex",
          "justify-content": "space-between"
        },
        "header-title": { float: "left" },
        "header-options": { float: "right" },
        "header-title--text": {
          "font-size": "20px",
          "vertical-align": "middle",
          "font-weight": "400",
          "line-height": "35px",
          "padding-left": "22px",
          "letter-spacing": "1px"
        },
        "header-title--html": {
          "font-size": "20px",
          "vertical-align": "middle",
          "font-weight": "400",
          "line-height": "35px",
          "padding-left": "22px",
          "letter-spacing": "1px"
        },
        "header-btn-recenter": {
          background: "#FFFFFF",
          border: "none",
          outline: "none",
          cursor: "pointer",
          color: "#081f26",
          "border-radius": '5px',
          "box-shadow": "0 0 5px rgba(0, 0, 0, 0.2)",
          padding: "0.375rem 0.75rem"
        },
        "header-slider": {
          "box-sizing": "content-box"
        },
        "header-slider-wrapper": {
          display: "inline-block",
          "vertical-align": "middle"
        },
        "header-slider--slider": { "box-sizing": "content-box" },
        "header-slider--process": { "box-sizing": "content-box" },
        "header-task-list-switch--label": { "box-sizing": "content-box","display": "none" },
        "header-task-list-switch": {
          margin: "0px 15px",
          "vertical-align": "middle",
          "display": "none"
        },
        "header-label": {
          "margin-left": "10px"
        }
      },
      options: {
        times: {
          timeScale: 60 * 1000,
          timeZoom: 21, //*
          timePerPixel: 0,
          firstTime: null,
          lastTime: null,
          firstTaskTime: 0,
          lastTaskTime: 0,
          totalViewDurationMs: 0,
          totalViewDurationPx: 0,
          stepDuration: 'day',
          steps: []
        },
        scope: {
          //*
          before: 16,
          after: 1
        },
        row: {
          height: 30 //*
        },
        chart: {
          progress: {
            bar: false,
          },
          expander: {
            display: true,
          },
        },
        taskList: {
          display: true, //*
          expander: {
            straight: false
          },
          columns: [
            {
              id: 1,
              label: 'Name',
              value: 'label',
              width: 200,
              expander: true,
              html: true
            },
            {
              id: 2,
              label: 'Progress',
              value: 'progress_percantage',
              width: 100,
              style: {
                'task-list-header-label': {
                  'text-align': 'center',
                  width: '100%',
                },
                'task-list-item-value-container': {
                  'text-align': 'center',
                  width: '100%',
                },
              },
            },
          ],
        },
        calendar: {
          hour: {
            display: false,
          },
          day: {
            height: 30,
            format: {
              long(date) {
                return date.format('DD');
              },
              medium(date) {
                return date.format('DD');
              },
              short(date) {
                return date.format('DD');
              }
            }
          }
        }
      }
    };
  },
  components: {
    Avatar,
    CreateProjectModal,
    GGanttChart,
    GGanttRow,
    GanttElastic,
    ProjectViewModal,
    ShowMoreModal,
    GanttHeader,
    GuideButton
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      this.loadProjects()
      this.loadProjectTemplates(true)
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getStoreShortPerPage() {
      return this.$store.state.shortPerPage
    },
    getPerPage() {
      let page = this.currentPage;
      let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
      let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
      let selectedOf = this.totalRows;

      if (selectedTo > selectedOf) {
        selectedTo = selectedOf
      }

      return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
    },
    getFilters() {
      return this.$store.state.activeFilters
    },
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    goToProject(slug) {
      this.$router.push({ name: 'projects.view', params: { slug: slug }})
    },
  },
  methods: {
    debounceInput: _.debounce(function() {
      this.loadProjects()
    }, 400),
    resetFilters() {
      this.filters.owners = [];
      this.filters.types = this.types;
      this.filters.future_projects = '';
      this.filters.overdue_projects = 0;
      this.filters.tags = [];
      this.debounceInput();
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Project' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Project',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    showTask(evt) {
      this.selectedProjectSlug = evt.data.slug
      this.viewProjectModal = true
    },
    closeViewProjectModal() {
      this.selectedProjectSlug = ''
      this.viewProjectModal = false
    },
    handleFilterButton(forceOpened) {
      if (!this.filterOpened) {
        this.loadUsers()
        this.loadTags()
      }
      if (forceOpened) {
        this.filterOpened = true
      } else {
        this.filterOpened = !this.filterOpened
      }
    },
    getReducedUsers(users) {
      let reducedUsers = []
      if (users && users.length > 3) {
        reducedUsers = _.cloneDeep(users);
        reducedUsers = reducedUsers.slice(0, 3);
      } else {
        reducedUsers = users;
      }
      return reducedUsers;
    },
    openUsersModal(object) {
      this.selectedItem = object
      this.showUsersModal = true
    },
    closeUsersModal() {
      this.selectedItem = {}
      this.showUsersModal = false
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment()
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    pageChanged(page) {
      this.loadProjects(page)
    },
    perPageChanged(perPage) {
      let self = this;
      this.loadProjects(1, perPage.value)
      self.selectedPerPage = perPage.value
      this.$store.commit('storePerPage', this.selectedPerPage);
    },
    perPageRemoved() {
      let self = this;
      // Load Third parties when page changed listener is triggered
      self.selectedPerPage = self.perPageOptions[0].value
      this.loadProjects(1, self.selectedPerPage)
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        translatable: newTag,
        name_translated: newTag
      }
      this.selectedTags.push(tag)
      this.newTags.push(tag)
    },
    loadTags(query) {
      let self = this;
      piincHttp.get('tags', { params:
        {
          client: this.getClient.slug,
          keyword: query ? query : undefined
        }
      }).then(function(response) {
        self.tags = response.data
        for (var i = 0; i < self.newTags.length; i++) {
          self.tags.push(self.newTags[i]);
        }
        if (self.tags && !self.tags.length && !query) {
          self.tags.push({name_translated: self.$t('system.no_results'), $isDisabled: true})
        }
      }, function() {});
    },
    loadProjects(page, perPage) {
      var moment = require('moment');

      if (this.getStoreShortPerPage) {
        this.selectedPerPage = this.getStoreShortPerPage;
      }

      // If page is not defined, set page to default 1
      let pageNumber = page ? page : 1;
      let perPageNumber = perPage ? perPage : this.selectedPerPage;
      let self = this;
      this.tasks = []
      this.loadingOpen = true;
      let formOwners = [];
      let formTypes = [];
      let formTags = [];

      // Append list of users to FormData
      if (this.filters.owners && this.filters.owners.length) {
        for (var i = 0; i < this.filters.owners.length; i++) {
          formOwners[i] = this.filters.owners[i].id;
        }
        this.handleFilterButton(true)
      }

      if (this.filters.overdue_projects) {
        this.handleFilterButton(true)
      }

      if (this.filters.types && this.filters.types.length) {
        for (var t = 0; t < this.filters.types.length; t++) {
          formTypes[t] = this.filters.types[t].value;
        }
        //this.handleFilterButton(true)
      }

      if (this.filters.tags && this.filters.tags.length) {
        for (var t = 0; t < this.filters.tags.length; t++) {
          formTags[t] = this.filters.tags[t].id;
        }
        this.handleFilterButton(true)
      }

      piincHttp.get('projects', { params:
        {
          page: pageNumber,
          per_page: perPageNumber,
          status: ['in progress', 'pending'],
          sort: 'end_date',
          control_type: 'one time',
          order: 'asc',
          client: this.getClient.slug,
          tags: formTags ? formTags : undefined,
          types: formTypes ? formTypes : undefined,
          owners: formOwners ? formOwners : undefined,
          future_projects: this.filters.future_projects ? this.filters.future_projects : undefined,
          overdue_projects: this.filters.overdue_projects ? this.filters.overdue_projects : undefined,
          keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
        }
      }).then(function(response) {
        _.forEach(response.data.items, function (item) {
          let start = new Date(Date.parse(item.start_date)).getTime();
          let duration = new Date(Date.parse(item.end_date)).getTime() - start;

          let responsibles = ''
          // _.forEach(item.users, function (user) {
          //
          //   let avatar = user.avatar.replace('/', '//');
          //   console.log(avatar);
          //   responsibles = responsibles + '<span title="" class="rounded-circle user-avatar xs" data-original-title="Client Administrator" style="margin-top: -2px; position: relative; background-image: url("'+avatar+'");"></span>';
          // });

          let object = {
            id: item.id,
            title: item.title,
            slug: item.slug,
            label: '<a href="/projects/view/'+item.slug+'">'+item.title+'</a>',
            // responsibles: responsibles,
            users: item.users,
            start: start,
            duration: duration,
            progress: item.progress,
            progress_percantage: item.progress + ' %',
            type: 'task',
            style: {
              base: {
                fill: '',
                stroke: ''
              }
            }
          }

          if (item.type == 'update') {
            object.style.base.fill = '#A25DDC'
            object.style.base.stroke = '#A25DDC'
          }

          if (item.type == 'validation') {
            object.style.base.fill = '#EBA31E'
            object.style.base.stroke = '#EBA31E'
          }

          if (item.type == 'control' || item.type == 'security_measure') {
            object.style.base.fill = '#39A9E1'
            object.style.base.stroke = '#39A9E1'
          }

          if (item.type == 'control_assessment' || item.type == 'risk_assessment' || item.type == 'bia_assessment') {
            object.style.base.fill = '#195458'
            object.style.base.stroke = '#195458'
          }

          self.tasks.push(object);
        })
        self.loadingOpen = false;
        // Set number of total items
        self.totalRows = response.data.total_count;
      }, function() {});
    },
    loadUsers(query) {
      let self = this;
      piincHttp.get('users', { params:
        {
          client: this.getClient.id,
          keyword: query ? query : undefined,
          per_page: 50
        }
      }).then(function(response) {
        self.users = response.data.items
        if (self.users && !self.users.length && !query) {
          self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
        }
      }, function() {});
    },
    loadProjectTemplates(reset) {
      if (reset) {
        this.myProjectTemplatesOpen = []
        this.projectTemplatesPage = 1;
        this.projectTemplatesShowMore = true;
      }
      let self = this;

      this.loadingProjectTemplates = true;
      piincHttp.get('projects', { params:
        {
          per_page: 5,
          control_type: 'continuous',
          page: this.projectTemplatesPage,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.myProjectTemplatesOpen.push(...response.data.items);
        self.loadingProjectTemplates = false;
        self.projectTemplatesPage = self.projectTemplatesPage + 1;

        if (!response.data.items.length) {
          self.loadingProjectTemplates = false;
        }
      }, function() {});
    },
  },
  beforeRouteLeave(to, from, next) {
    let object = {
      type: 'project_landing',
      filters: this.filters
    }
    this.$store.commit('storeActiveFilters', object);
    this.$store.commit('storeShortPerPage', this.selectedPerPage);
    next()
  },
  created() {
    if (this.getClient && this.getClient.slug) {
      if (this.getFilters.project_landing) {
        this.filters = this.getFilters.project_landing
      }
      this.loadProjects()
      this.loadProjectTemplates()
    }
    this.loadGuides('gantt_page');

  }
}

</script>
